import moment from "moment-timezone"
import Config from "react-global-configuration"
import { useAuth } from "../services"
import { POST_TYPE } from "../data"

const usePostUtils = () => {
  const { isCurrentUser, location } = useAuth()
  const config = Config.get()

  const getScheduleFormattedDate = (visibleFrom) =>
    moment(visibleFrom).tz(location.timeZone).format("D MMM YYYY [at] h:mm A z")

  const getNavigateToLink = (post) =>
    post.type === POST_TYPE.CAMPAIGN ? getNavigateToCampaignLink(post) : getNavigateToPostLink(post)
  const getNavigateToPostLink = (post) => `/hub/post/${post.id}`
  const getNavigateToCampaignLink = (post) => `/hub/campaign/${post.id}`
  const getFullNavigateToLink = (post) =>
    `${config.clientLinkBaseUri || config.clientBaseUri}${getNavigateToLink(post)}`

  const isCurrentUserAuthorOf = (post) => isCurrentUser(post.author.id)

  const hasCurrentUserConfirmedPost = (post) => post.currentUserNotification?.confirmed
  const hasCurrentUserReceivedPostNotification = (post) => !!post.currentUserNotification

  const isDateInFuture = (date) => date && moment().isBefore(date)
  const isScheduledInFuture = (post) => post && post.visibleFrom && isDateInFuture(post.visibleFrom)

  return {
    getScheduleFormattedDate,
    getNavigateToLink,
    getNavigateToPostLink,
    getNavigateToCampaignLink,
    getFullNavigateToLink,

    isCurrentUserAuthorOf,
    isScheduledInFuture,
    isDateInFuture,

    hasCurrentUserConfirmedPost,
    hasCurrentUserReceivedPostNotification
  }
}

export { usePostUtils }
